// extracted by css-extract-rspack-plugin
export default {"searchListContainer":"IssueDashboardCustomViewPage-module__searchListContainer__MGWEp"};